// RankingCompareModalV2 공통 상수
// 원본 RankingCompareModal.js 의 상수들을 그대로 추출

// 단지 구분용 팔레트 — 서로 인접 색이 겹치지 않도록 대비 큰 카테고리 색으로 교체
export const PALETTE = ['#2563eb', '#dc2626', '#16a34a', '#d97706', '#7c3aed', '#0891b2', '#db2777', '#4d7c0f', '#ea580c', '#4f46e5'];
export const STAR_SYMBOL_PATH = 'path://M512 64l128.6 260.6L928 366.4l-208 202.7L769.2 864 512 729.6 254.8 864 304 569.1 96 366.4l287.4-41.8L512 64z';

export const METRIC_COLORS = {
  topPrice: '#dc2626',
  salePrice: '#2563eb',
  saleRealPrice: '#1d4ed8',
  leasePrice: '#d97706',
  leaseRealPrice: '#b45309',
  leasePriceRate: '#7c3aed',
  saleRecent8Weeks: '#059669',
  leaseRecent8Weeks: '#ea580c',
  saleCount: '#16a34a',
  saleRealCount: '#15803d',
  leaseCount: '#0ea5e9',
  leaseRealCount: '#0369a1',
};

// 항목별로 라인 종류(dash 패턴)를 확실히 다르게 → 같은 단지(같은 색) 안에서도 항목 구분 쉬움.
// dash: 'solid' | number[] (ECharts lineStyle.type). desc: 범례 표기용 라벨.
export const CHART_METRICS = [
  // 매매/전세 호가·실거래가는 같은 그룹(둘 중 하나만 표시). 실선 + 데이터 지점마다 동그라미(최근8주 스타일).
  { key: 'salePrice', label: '매매호가', dash: 'solid', desc: '실선', width: 2.5, withSymbol: true },
  { key: 'saleRealPrice', label: '매매실거래가', dash: 'solid', desc: '실선', width: 2.5, withSymbol: true },
  { key: 'leasePrice', label: '전세호가', dash: 'solid', desc: '실선', width: 2.5, withSymbol: true },
  { key: 'leaseRealPrice', label: '전세실거래가', dash: 'solid', desc: '실선', width: 2.5, withSymbol: true },
  { key: 'leasePriceRate', label: '전세가율', dash: [14, 5, 3, 5], desc: '일점쇄선', width: 2.4, yAxisIndex: 1 },
];

export const SALE_MAIN_METRICS = ['salePrice', 'saleRealPrice', 'leasePriceRate', 'saleRecent8Weeks'];
export const LEASE_MAIN_METRICS = ['leasePrice', 'leaseRealPrice', 'leasePriceRate', 'leaseRecent8Weeks'];

export const METRIC_TOGGLES = [
  { key: 'topPrice', label: '최고가' },
  { key: 'salePrice', label: '매매호가' },
  { key: 'saleRealPrice', label: '매매실거래가' },
  { key: 'leasePrice', label: '전세호가' },
  { key: 'leaseRealPrice', label: '전세실거래가' },
  { key: 'leasePriceRate', label: '전세가율' },
  { key: 'saleRecent8Weeks', label: '매매 최근8주' },
  { key: 'leaseRecent8Weeks', label: '전세 최근8주' },
  { key: 'saleCount', label: '매매 매물수' },
  { key: 'saleRealCount', label: '매매 실거래건수' },
  { key: 'leaseCount', label: '전세 매물수' },
  { key: 'leaseRealCount', label: '전세 실거래건수' },
];

export const BRUSH_PANEL_METRICS = {
  saleTop: [
    { key: 'salePrice', label: '매매호가', format: 'krw' },
    { key: 'saleRealPrice', label: '매매실거래가', format: 'krw' },
  ],
  leaseTop: [
    { key: 'leasePrice', label: '전세호가', format: 'krw' },
    { key: 'leaseRealPrice', label: '전세실거래가', format: 'krw' },
  ],
  saleCount: [
    { key: 'saleCount', label: '매매 매물수' },
    { key: 'saleRealCount', label: '매매 실거래건수' },
  ],
  leaseCount: [
    { key: 'leaseCount', label: '전세 매물수' },
    { key: 'leaseRealCount', label: '전세 실거래건수' },
  ],
};

export const MAX_RANGE_YEARS = 10;

// 차트 종류별(매매/전세) 토글 키 — 렌더 중복 제거용
export const TOP_TOGGLE_KEYS = {
  sale: ['topPrice', 'salePrice', 'saleRealPrice', 'leasePriceRate', 'saleRecent8Weeks'],
  lease: ['topPrice', 'leasePrice', 'leaseRealPrice', 'leasePriceRate', 'leaseRecent8Weeks'],
};
// 상단 가격차트 토글을 2그룹(구분선)으로 표시: [호가↔실거래가 라디오] | [나머지 체크박스]
export const TOP_TOGGLE_GROUPS = {
  sale: [
    { exclusive: true, keys: ['salePrice', 'saleRealPrice'] },
    { exclusive: false, keys: ['topPrice', 'leasePriceRate', 'saleRecent8Weeks'] },
  ],
  lease: [
    { exclusive: true, keys: ['leasePrice', 'leaseRealPrice'] },
    { exclusive: false, keys: ['topPrice', 'leasePriceRate', 'leaseRecent8Weeks'] },
  ],
};
export const COUNT_TOGGLE_KEYS = {
  sale: ['saleCount', 'saleRealCount'],
  lease: ['leaseCount', 'leaseRealCount'],
};

// 최근8주 토글은 '실거래가' 라디오가 켜졌을 때만 노출.
// 호가(매매호가/전세호가)가 선택되면 해당 최근8주 토글을 그룹에서 제거해 감춘다.
// forceHideRecent8=true 이면(단지 2개 이상 통합차트 등) 조건과 무관하게 항상 제거.
export const buildTopToggleGroups = (variant, metricVisible = {}, forceHideRecent8 = false) => {
  const groups = TOP_TOGGLE_GROUPS[variant] || [];
  const recentKey = variant === 'sale' ? 'saleRecent8Weeks' : 'leaseRecent8Weeks';
  const realOn = variant === 'sale'
    ? metricVisible.saleRealPrice === true
    : metricVisible.leaseRealPrice === true;
  if (realOn && !forceHideRecent8) return groups;
  return groups.map((g) => ({ ...g, keys: (g.keys || []).filter((k) => k !== recentKey) }));
};

// 차트 종류별 구간비교(브러시) 패널 설정
export const TOP_BRUSH = {
  sale: { title: '구간비교 (매매)', metrics: BRUSH_PANEL_METRICS.saleTop },
  lease: { title: '구간비교 (전세)', metrics: BRUSH_PANEL_METRICS.leaseTop },
};
export const COUNT_BRUSH = {
  sale: { title: '구간비교 (매매 수량)', metrics: BRUSH_PANEL_METRICS.saleCount },
  lease: { title: '구간비교 (전세 수량)', metrics: BRUSH_PANEL_METRICS.leaseCount },
};

export const TOP_OPTION_PREFIX = { sale: 'ranking-compare-top-sale', lease: 'ranking-compare-top-lease' };
export const COUNT_OPTION_PREFIX = { sale: 'ranking-compare-sale-count', lease: 'ranking-compare-lease-count' };
